module.exports = __webpack_public_path__ + "img/danghui.6c41ddca.png";